module.exports = __webpack_public_path__ + "flyer_background_confetti_two_045-3a4f491e3d922fa156541667b44a562e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Backgrounds/flyer_background_confetti_two_045.jpg
// module id = 1629
// module chunks = 1